// extracted by mini-css-extract-plugin
module.exports = {"container":"DocumentEmbed_container__2o5Sm","controls":"DocumentEmbed_controls__qsMI9","disabled":"DocumentEmbed_disabled__2Re60"};